import o from "./index49.js";
import f from "./index79.js";
function d(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function S(e, i, c) {
  if (!i)
    return e;
  e = e || "";
  const n = o.isFunction(c) ? {
    serialize: c
  } : c, s = o.getSafeProp(n, "encode") || d, r = o.getSafeProp(n, "serialize");
  let t;
  if (r ? t = r(i, n) : t = o.isURLSearchParams(i) ? i.toString() : new f(i, n).toString(s), t) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + t;
  }
  return e;
}
export {
  S as default,
  d as encode
};
